import { useState, useEffect, useCallback } from 'react';

import { getPaginatedTeachers } from '../api/teacher.api';
import { mapProfileToTeacher } from '../utils/teacherMapper';

export default function useTeachers(page = 1, perPage = 15, filters = {}) {
  const { search = '', subject = '', status = '' } = filters;
  const [teachers, setTeachers] = useState([]);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTeachers = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const res = await getPaginatedTeachers(page, perPage, { search, subject, status });

      if (res.data) {
        const mappedTeachers = res.data.data.map(mapProfileToTeacher);

        setTeachers(mappedTeachers);
        setMeta(res.data.meta);
      }
    } catch (err) {
      setError('Failed to load teachers. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [page, perPage, search, subject, status]);

  useEffect(() => {
    fetchTeachers();
  }, [fetchTeachers]);

  return { teachers, meta, loading, error, refetch: fetchTeachers };
}
